/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNumber0Small = createReactComponent("number-0-small", "IconNumber0Small", [
  ["path", { d: "M10 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z", key: "svg-0" }]
]);

export { IconNumber0Small as default };
//# sourceMappingURL=IconNumber0Small.js.map
